module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-gray-dark-on-white-a00f5078fe766215d066fe37489d4429.png";